export const asErrMsgKey = (validationResult) =>
  validationResult === false ? 'invalid' : typeof validationResult === 'string' ? validationResult : '';

const mapKeysToErrMsgs = new Map([
  ['invalid', '%s cannot be empty'],
  ['empty', '%s cannot be empty'],
  ['ph_to_short', 'Mobile number must be 10 digits'],
  ['cohort_to_long', 'Entered title exceeds 70 characters'],
  ['cohort_name__already_exist', 'Entered Cohort name is already exists'],
]);

export const formatString = (rawStr, ...values) => {
  return values.reduce((s, v) => s.replace('%s', v), rawStr);
};

export const getErrMsgByErrKey = (errKey, fieldTitle) => {
  const errMsgRaw = mapKeysToErrMsgs.get(errKey) || '';
  return formatString(errMsgRaw, fieldTitle);
};

const regEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isEmailValid = (value) => {
  return regEmail.test(value);
};

export const isPhoneNumberValid = (value) => {
  return value ? (value.length >= 10 ? true : 'ph_to_short') : false;
};

export const isCohortNameValid = (value) => {
  return value ? (value.length <= 70 ? true : 'cohort_to_long') : false;
};

export const isValueValid = (value) => {
  return !!value;
};

export const validateEmail = (value) => asErrMsgKey(isEmailValid(value));
export const validatePhoneNumber = (value) => asErrMsgKey(isPhoneNumberValid(value));
export const validateCohortName = (value) => asErrMsgKey(isCohortNameValid(value));
export const validateAny = (value) => asErrMsgKey(isValueValid(value));

// Checks if the cohort name already exists in the list
export const isCohortNameExist = (name, cohortList, isEdit = false, editId = null) => {
  const normalizedInput = name.trim().toLowerCase();
  let isExist = false;
  if (isEdit && editId) {
    isExist = cohortList.some((cohort) => cohort.name.trim().toLowerCase() === normalizedInput && cohort.id != editId);
  } else {
    isExist = cohortList.some((cohort) => cohort.name.trim().toLowerCase() === normalizedInput);
  }
  return isExist ? 'cohort_name__already_exist' : '';
};
// any non-empty values are considered as error state
export const hasAnyError = (errObj) => {
  return Object.values(errObj).filter((v) => !!v).length > 0;
};
